import { dashboardWidgetsPermissionConfig } from '@/_shared';

import { Layout } from '../widget-financial-snapshot-graph-card/layout';
import { Loading as FinancialSnapshotGraphCardLoading } from '../widget-financial-snapshot-graph-card/loading';

export function CreditCardFundsAvailableLoading() {
  return (
    <Layout title={dashboardWidgetsPermissionConfig['credit_card_funds_available'].name}>
      <FinancialSnapshotGraphCardLoading />
    </Layout>
  );
}
